const formatAdditionalGuests = (additionalGuests) => {
  additionalGuests.forEach((guest) => {
    const firstName = guest.first_name ? `${guest.first_name} ` : '';
    const lastName = guest.last_name ? guest.last_name : '';
    guest.full_name = firstName + lastName;
  });
  return additionalGuests;
};

export { formatAdditionalGuests };
